/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Incomplete_DetailsInputs */

const en_us2_workout_after_incomplete_details = /** @type {(inputs: Workout_After_Incomplete_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete the highlighted questions.`)
};

const pt_br2_workout_after_incomplete_details = /** @type {(inputs: Workout_After_Incomplete_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complete as perguntas destacadas.`)
};

const es_419_workout_after_incomplete_details = /** @type {(inputs: Workout_After_Incomplete_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa las preguntas destacadas.`)
};

const pt_pt2_workout_after_incomplete_details = /** @type {(inputs: Workout_After_Incomplete_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa as perguntas destacadas.`)
};

const fr_fr2_workout_after_incomplete_details = /** @type {(inputs: Workout_After_Incomplete_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Complète les questions en surbrillance.`)
};

const de_de2_workout_after_incomplete_details = /** @type {(inputs: Workout_After_Incomplete_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beantworte die markierten Fragen.`)
};

const it_it2_workout_after_incomplete_details = /** @type {(inputs: Workout_After_Incomplete_DetailsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Completa le domande evidenziate.`)
};

/**
* | output |
* | --- |
* | "Complete the highlighted questions." |
*
* @param {Workout_After_Incomplete_DetailsInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_incomplete_details = /** @type {((inputs?: Workout_After_Incomplete_DetailsInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Incomplete_DetailsInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_incomplete_details(inputs)
	if (locale === "es-419") return es_419_workout_after_incomplete_details(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_incomplete_details(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_incomplete_details(inputs)
	if (locale === "de-DE") return de_de2_workout_after_incomplete_details(inputs)
	if (locale === "it-IT") return it_it2_workout_after_incomplete_details(inputs)
	return en_us2_workout_after_incomplete_details(inputs)
});
export { workout_after_incomplete_details as "workout-after.incomplete_details" }